export const CONDITIONAL_TILES_SUPPRESSION_EXPERIMENT =
  'car-merch-ui-srp-conditional-tiles-suppression';
